import { parsePhoneNumberFromString } from "libphonenumber-js";

export const formatPhoneNumber = (phoneNumber: string) => {
    const phoneObj = parsePhoneNumberFromString(phoneNumber);
    if (phoneObj) {
        return phoneObj.formatInternational();
    }
    return phoneNumber;
};
